import React, {useEffect, useState} from "react";
import {Col, Modal, Row, Spinner} from "react-bootstrap";
import {
    aiModuleTemplateTypes,
    formatAIDocumentColor,
    formatAIDocumentStatus,
    vatDeductibleToleranceLabels
} from "./aiHelper";
import {
    setAIModuleType,
    setAIMrModuleData,
    setAIMrModuleRequestData, setAIMrModuleSelectedRows
} from "../../../../_reducers/aiSlice";
import Dropdown from "../../../primer/Dropdown";
import {useDispatch, useSelector} from "react-redux";
import {getCurrentUser, getGreekCurrencyFormat, isEmpty} from "../../../../_helpers/commonFunctions";
import axios from "axios";
import {toast} from "react-toastify";
import {getInvoiceTypeDescription} from "../../../../_data/mydata/salesInvoiceTypes";
import {Popconfirm} from "antd";
import {FaArrowDown, FaArrowUp, FaFileInvoice, FaRobot} from "react-icons/fa";
import {TbReload} from "react-icons/tb";
import {MdDeselect, MdOutlineCancel} from "react-icons/md";
import ReportsTemplate from "../../../common/ReportsTemplate";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import DateBox from "../../../primer/DateBox";
import moment from "moment/moment";
import {getInvoiceTypesOptions} from "../../../../_helpers/sharedmydata";
import Input from "../../../common/Input";
import Pagination from "../../../primer/Pagination";
import Button from "react-bootstrap/esm/Button";
import AISaveSaleModal from "./components/aiSaveSaleModal";
import AISaveBuyModal from "./components/aiSaveBuyModal";
import {openBuyLocal, openSaleLocal} from "../../../../_helpers/tabOpeners";
import StatusSlider from "../../../primer/StatusSlider/StatusSlider";

const AIModuleMyDataClearance = () => {
    const dispatch = useDispatch();
    const aiModuleType = useSelector((state) => state.AI.aiModuleType);
    const aiSettings = useSelector((state) => state.AI.aiSettings);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const requestData = useSelector((state) => state.AI.aiMrModuleRequestData);
    const aiModuleData = useSelector((state) => state.AI.aiMrModuleData);
    const aiModuleSelectedRows = useSelector((state) => state.AI.aiMrModuleSelectedRows);
    const tableData = aiModuleData.data;
    const [pageChanged, setPageChanged] = useState(false);
    const invoiceTypes = [{value: "sendClassification", label: "Προς Χαρακτηρισμό"}, {value: "sendInvoice", label: "Προς Αποστολή"}, ...getInvoiceTypesOptions("all")];

    const [aiDoc, setAIDoc] = useState(null);
    const [showSaleModal, setShowSaleModal] = useState(false);
    const [showBuyModal, setShowBuyModal] = useState(false);
    const [showReprocessModal, setShowReprocessModal] = useState(false);
    const [loadingReprocess, setLoadingReprocess] = useState(false);
    const [showDeclineModal, setShowDeclineModal] = useState(false);
    const [loadingDecline, setLoadingDecline] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [savingSomething, setSavingSomething] = useState(false);
    const [massLoading, setMassLoading] = useState(false);
    const statusesForCheckboxes = [-121, -122, -123, 499, 500, -501];
    const statusesForClickableRows = [499, 500];

    const isAdmin = getCurrentUser()?.userType === "Admin";
    const typeOptions = [{label: "Κενό", value: ""}, {label: "Πωλήσεις", value: "Πωλήσεις"}, {label: "Αγορές & Δαπάνες", value: "Αγορές & Δαπάνες"}];

    const [vatDeductibleSlider, setVatDeductibleSlider] = useState(aiSettings?.vatDeductibleTolerance || 3);

    useEffect(() => {
        if(isEmpty(requestData.date_to) && isEmpty(requestData.date_from)) {
            const currentYear = Number(moment().format("YYYY"));
            if (Number(company.year) < currentYear) {
                dispatch(setAIMrModuleRequestData({...requestData, date_from: `01/01/${company.year}`, date_to: `31/12/${company.year}`, forceFetch: true}));
            } else {
                const dateFrom = moment().month() === 0 ? moment().startOf("month").format("DD/MM/YYYY") : moment().subtract(1, "month").startOf("month").format("DD/MM/YYYY");
                const dateTo = moment().month() === 0 ? moment().endOf("month").format("DD/MM/YYYY") : moment().subtract(1, "month").endOf("month").format("DD/MM/YYYY");
                dispatch(setAIMrModuleRequestData({...requestData, date_from: dateFrom, date_to: dateTo, forceFetch: true}));
            }
        }
    }, [])

    useEffect(() => {
        if (!showReprocessModal) setVatDeductibleSlider(aiSettings?.vatDeductibleTolerance || 3);
    }, [showReprocessModal]);

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchData(true);
        }
    }, [pageChanged])

    useEffect(() => {
        if(requestData?.forceFetch) {
            fetchData(false);
        }
    }, [requestData?.forceFetch]);

    const fetchData = (fromPagination = false) => {
        setLoadingData(true);
        const reqData = {...requestData, forceFetch: false};
        if (!fromPagination) {
            reqData.page = 1;
            dispatch(setAIMrModuleRequestData(reqData));
            dispatch(setAIMrModuleSelectedRows([]));
        }
        axios.post(`${process.env.REACT_APP_API_URL2}/ai/ai-mr-module`, {
            ...reqData,
            company: company.id,
            year: company.year,
        }).then((res) => {
            setLoadingData(false);
            if (res.data.status === "200") {
                dispatch(setAIMrModuleData(res.data.data));
            }
        }).catch((err) => {
            setLoadingData(false);
            console.log(err);
        })
    }

    const fetchDataForMass = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL2}/ai/ai-mr-module`, {
                ...requestData,
                page: -1,
                company: company.id,
                year: company.year,
            });
            if (res.data.status === "200") {
                return (res.data.data.data || []).filter((el) => statusesForCheckboxes.includes(el.erp_status));
            }
        } catch (err) {
            console.log(err);
        }
        return [];
    }

    const onSave = (o) => {
        if (savingSomething) return toast.warning("Παρακαλώ περιμένετε να τελειώσει η προηγούμενη καταχώρηση.");
        if (o.type === "Πωλήσεις") {
            setAIDoc(o);
            setShowSaleModal(true);
        } else if (o.type === "Αγορές & Δαπάνες") {
            setAIDoc(o);
            setShowBuyModal(true);
        }
    }

    const onFastSave = async (o, fromMass = false) => {
        if (savingSomething) return toast.warning("Παρακαλώ περιμένετε να τελειώσει η προηγούμενη καταχώρηση.");
        if (o.type === "Πωλήσεις") {
            await handleSaleSave(o, null, null, fromMass);
        } else if (o.type === "Αγορές & Δαπάνες") {
            await handleSaveBuy(o, null, null, fromMass);
        }
    }

    const onMassFastSave = async () => {
        if (savingSomething) return toast.warning("Παρακαλώ περιμένετε να τελειώσει η προηγούμενη ενέργεια.");
        setMassLoading(true);
        let rows = aiModuleSelectedRows;
        if (rows.length === 0) rows = await fetchDataForMass();
        for (const aiDoc of rows) {
            await onFastSave(aiDoc, true);
        }
        setMassLoading(false);
        toast.success("Επιτυχής ενέργεια.");
        fetchData(true);
        dispatch(setAIMrModuleSelectedRows([]));
    }

    const onReprocess = (o) => {
        setAIDoc(o);
        setShowReprocessModal(true);
        if (showSaleModal) setShowSaleModal(false);
        if (showBuyModal) setShowBuyModal(false);
    }

    const onMassReprocess = async () => {
        if (savingSomething) return toast.warning("Παρακαλώ περιμένετε να τελειώσει η προηγούμενη ενέργεια.");
        setMassLoading(true);
        let rows = aiModuleSelectedRows;
        if (rows.length === 0) rows = await fetchDataForMass();
        for (const aiDoc of rows) {
            await onReprocessDocument(aiDoc, true);
        }
        setMassLoading(false);
        toast.success("Επιτυχής ενέργεια.");
        fetchData(true);
        dispatch(setAIMrModuleSelectedRows([]));
    }

    const onReprocessDocument = async (aiDoc, fromMass) => {
        setLoadingReprocess(true);
        await axios.post(`${process.env.REACT_APP_API_URL2}/ai/reprocess-mr-invoice`, {
            company: company.id,
            invoiceId: aiDoc._id,
            vatDeductibleTolerance: vatDeductibleSlider,
        }).then((res) => {
            setLoadingReprocess(false);
            if (res.data.status === "200") {
                setShowReprocessModal(false);
                if (!fromMass) {
                    fetchData(true);
                    toast.success("Επιτυχής αίτημα επαναεπεξεργασίας.");
                }
            } else {
                if (!fromMass) fetchData(true);
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoadingReprocess(false);
            console.log(err);
            if (!fromMass) toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const onDecline = (o) => {
        if (savingSomething) return toast.warning("Παρακαλώ περιμένετε να τελειώσει η προηγούμενη ενέργεια.");
        setAIDoc(o);
        setShowDeclineModal(true);
        if (showSaleModal) setShowSaleModal(false);
        if (showBuyModal) setShowBuyModal(false);
    }

    const onMassDecline = async () => {
        if (savingSomething) return toast.warning("Παρακαλώ περιμένετε να τελειώσει η προηγούμενη ενέργεια.");
        setMassLoading(true);
        let rows = aiModuleSelectedRows;
        if (rows.length === 0) rows = await fetchDataForMass();
        for (const aiDoc of rows) {
            await onDeclineDocument(aiDoc, true);
        }
        setMassLoading(false);
        toast.success("Επιτυχής ενέργεια.");
        fetchData(true);
        dispatch(setAIMrModuleSelectedRows([]));
    }

    const onDeclineDocument = async (aiDoc, fromMass = false) => {
        setLoadingDecline(true);
        await axios.post(`${process.env.REACT_APP_API_URL2}/ai/decline-mr-invoice`, {
            company: company.id,
            invoiceId: aiDoc._id
        }).then((res) => {
            setLoadingDecline(false);
            if (res.data.status === "200") {
                setShowDeclineModal(false);
                if (!fromMass) {
                    fetchData(true);
                    toast.success("Επιτυχής απόρριψη.");
                }
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoadingDecline(false);
            console.log(err);
            if (!fromMass) toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const renderActionButtons = (o) => {
        let arr = [];
        if (o["erp_status"] === 500) {
            arr.push(<div key={"onFastSave"} className={"ai-module-button ai-module-save-style"} title={"Γρήγορη καταχώρηση"} onClick={(e) => {
                e.stopPropagation();
                onFastSave(o)
            }}><FaRobot size={22} /></div>);
            arr.push(<div key={"onReprocess"} className={"ai-module-button ai-module-reprocess-style"} title={"Επαναεπεξεργασία"} onClick={(e) => {
                e.stopPropagation();
                onReprocess(o)
            }}><TbReload size={22} /></div>);
            /*arr.push(<div key={"onSave"} className={"ai-module-button ai-module-save-style"} title={"Προβολή & Καταχώρηση"} onClick={(e) => {
                e.stopPropagation();
                onSave(o)
            }}><FaSave size={22} /></div>); */
            arr.push(<div key={"onDecline"} className={"ai-module-button ai-module-decline-style"} title={"Απόρριψη"} onClick={(e) => {
                e.stopPropagation();
                onDecline(o)
            }}><MdOutlineCancel size={22} /></div>);
        } else if (o["erp_status"] === -501) {
            arr.push(<div key={"onReprocess"} className={"ai-module-button ai-module-reprocess-style"} title={"Επαναεπεξεργασία"} onClick={(e) => {
                e.stopPropagation();
                onReprocess(o)
            }}><TbReload size={22} /></div>);
        } else if ([-121, -122, -123].includes(o["erp_status"])) {
            arr.push(<div key={"onReprocess"} className={"ai-module-button ai-module-reprocess-style"} title={"Επαναεπεξεργασία"} onClick={(e) => {
                e.stopPropagation();
                onReprocess(o)
            }}><TbReload size={22} /></div>);
        } else if (o["erp_status"] === 499) {
           /* arr.push(<div key={"onSave"} className={"ai-module-button ai-module-save-style"} title={"Προβολή & Καταχώρηση"} onClick={(e) => {
                e.stopPropagation();
                onSave(o)
            }}><FaSave size={22} /></div>); */
        } else if ([1000, 1001].includes(o["erp_status"])) {
            arr.push(<div key={"handleShowExisting"} className={"ai-module-button ai-module-actions-style"} title={"Προβολή Παραστατικού"} onClick={(e) => {
                e.stopPropagation();
                if(o["type"] === "Πωλήσεις") {
                    handleShowExistingSale(o);
                } else if (o["type"] === "Αγορές & Δαπάνες") {
                    handleShowExistingBuy(o);
                }
            }}><FaFileInvoice size={22} /></div>);
        }
        if (arr.length > 0) arr.push(<br key={"br"}/>);
        return arr;
    }

    const handleFilterChange = (e, type, name) => {
        const prepChange = {};
        if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "msdd") {
            prepChange[name] = e.flatMap((o) => o.value);
        } else if (type === "input") {
            if (name === "scoreFrom" || name === "scoreTo") {
                prepChange[name] = (isEmpty(e.target.value) || isNaN(+e.target.value)) ? "" : +e.target.value;
            } else {
                prepChange[name] = e.target.value;
            }
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                return dispatch(setAIMrModuleRequestData({...requestData, [name] : moment(e).format("DD/MM/YYYY")}));
            } else {
                return dispatch(setAIMrModuleRequestData({...requestData, [name] : ""}));
            }
        }
        dispatch(setAIMrModuleRequestData({...requestData, ...prepChange}));
    }

    const statusOptions = [
        {label: "Καταχωρημένο", value: "complete"},
        {label: "Αναμονή ενέργειας χρήστη", value: "waiting_user"},
        {label: "Επεξεργασία από AI", value: "pending"},
        {label: "Απόρριψη από χρήστη", value: "declined"},
        {label: "Σφάλμα", value: "error"},
    ]



    const onPageChange = (page) => {
        setPageChanged(true);
        dispatch(setAIMrModuleRequestData({...requestData, page}));
    }

    const handleSort = (sortBy) => {
        let sortType;
        if (requestData.sortBy === sortBy) {
            if (requestData.sortType === "1") {
                sortType = "-1";
            } else if (requestData.sortType === "-1") {
                sortType = "";
            } else {
                sortType = "1";
            }
        } else {
            sortType = "1";
        }
        setPageChanged(true);
        dispatch(setAIMrModuleRequestData({...requestData, sortBy, sortType}))
    }

    const renderSortArrow = (sortBy) => {
        if (requestData.sortBy === sortBy) {
            if (requestData.sortType === "1") {
                return <React.Fragment><FaArrowDown /></React.Fragment>
            } else if (requestData.sortType === "-1") {
                return <React.Fragment><FaArrowUp /></React.Fragment>
            }
        }
        return <React.Fragment></React.Fragment>
    }

    const handleSaleSave = async (aiDoc, saleObject, setLoading, fromMass = false) => {
        if (saleObject?.products && saleObject.products.some((el) => isEmpty(el.name))) return toast.error("Παρακαλώ επιλέξτε είδη σε όλες τι γραμμές παραστατικού.");
        setSavingSomething(true);
        if (setLoading) setLoading(true);
        await axios.post(`${process.env.REACT_APP_API_URL2}/ai/accept-mr-invoice`, {
            company: company.id,
            invoiceId: aiDoc._id,
            document: saleObject,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            setSavingSomething(false);
            if (setLoading) setLoading(false);
            if (res.data.status === "200") {
                setShowSaleModal(false);
                if (!fromMass) {
                    fetchData(true);
                    toast.success("Επιτυχής καταχώρηση.");
                }
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setSavingSomething(false);
            if (setLoading) setLoading(false);
            console.log(err);
            if (!fromMass) toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        })
    }

    const handleSaveBuy = async (aiDoc, buyObject, setLoading, fromMass = false) => {
        if (buyObject?.products && buyObject.products.some((el) => isEmpty(el.name))) return toast.error("Παρακαλώ επιλέξτε είδη σε όλες τι γραμμές παραστατικού.");

        setSavingSomething(true);
        if (setLoading) setLoading(true);
        await axios.post(`${process.env.REACT_APP_API_URL2}/ai/accept-mr-invoice`, {
            company: company.id,
            invoiceId: aiDoc._id,
            document: buyObject,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            setSavingSomething(false);
            if (setLoading) setLoading(false);
            if (res.data.status === "200") {
                setShowBuyModal(false);
                if (!fromMass) {
                    fetchData(true);
                    toast.success("Επιτυχής καταχώρηση.");
                }
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setSavingSomething(false);
            if (setLoading) setLoading(false);
            console.log(err);
            if (!fromMass) toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        })
    }

    const handleSelectionChange = (e, aiDoc) => {
        e.stopPropagation();
        if (e.target.checked) {
            dispatch(setAIMrModuleSelectedRows([...aiModuleSelectedRows, aiDoc]));
        } else {
            dispatch(setAIMrModuleSelectedRows(aiModuleSelectedRows.filter((el) => !(el._id === aiDoc._id))));
        }
    }

    const handleShowExistingBuy = (invoice) => {
        if (invoice?.erp_document) {
            axios.get(process.env.REACT_APP_API_URL2 + "/company/get-document-by-id", {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: company.id,
                    docId: invoice.erp_document,
                    section: "Buys",
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    if (res.data.data) {
                        dispatch(openBuyLocal(res.data.data, TABS_DATA));
                    } else {
                        toast.error("Σφάλμα κατά την φόρτωση της αγοράς.");
                    }
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else if (invoice.mark) {
            axios.get(process.env.REACT_APP_API_URL2 + "/buy/get-buy-by-mark", {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: company.id,
                    mark: invoice.mark,
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    if (res.data.data) {
                        dispatch(openBuyLocal(res.data.data, TABS_DATA));
                    } else {
                        toast.error("Σφάλμα κατά την φόρτωση της αγοράς.");
                    }
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else {
            toast.error("Σφάλμα κατά την εύρεση του ΜΑΡΚ.");
        }
    }

    const handleShowExistingSale = (invoice) => {
        if (invoice?.erp_document) {
            axios.get(process.env.REACT_APP_API_URL2 + "/company/get-document-by-id", {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: company.id,
                    docId: invoice.erp_document,
                    section: "Sales",
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    if (res.data.data) {
                        dispatch(openSaleLocal(res.data.data, TABS_DATA));
                    } else {
                        toast.error("Σφάλμα κατά την φόρτωση της αγοράς.");
                    }
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else if (invoice.mark) {
            axios.get(process.env.REACT_APP_API_URL2 + "/sale/get-sale-by-mark", {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: company.id,
                    mark: invoice.mark,
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    if (res.data.data) {
                        dispatch(openSaleLocal(res.data.data, TABS_DATA));
                    } else {
                        toast.error("Σφάλμα κατά την φόρτωση της αγοράς.");
                    }
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else {
            toast.error("Σφάλμα κατά την εύρεση του ΜΑΡΚ.");
        }
    }

    const renderMassActions = () => {
        return (
            <div>
                {(aiModuleSelectedRows.length > 0 || (aiModuleData.massRegisterApplicable || aiModuleData.massDeclineApplicable || aiModuleData.massDeclineApplicable)) && (
                    <div className={"text-muted"} style={{fontStyle: "italic", textDecoration: "underline", textDecorationStyle: "dotted"}}
                         title={"Κάθε μαζική ενέργεια εφαρμόζεται μόνο στις εγγραφές που είναι πραγματοποιήσιμη"}
                    >
                        Μαζικές Ενέργειες
                    </div>
                )}
                {aiModuleSelectedRows.length > 0 ? (
                    <div>
                        Έχετε επιλέξει {aiModuleSelectedRows.length} {aiModuleSelectedRows.length === 1 ? "γραμμή" : "γραμμές"}
                        <Popconfirm
                            title={"Καταχώρηση επιλεγμένων"}
                            description={"Είσαστε σίγουροι ότι θέλετε να καταχωρήσετε τις επιλογές σας;"}
                            onConfirm={() => onMassFastSave()}
                            okText={"Ναι"}
                            cancelText={"Όχι"}
                        >
                            <div className={"ai-module-button ai-module-save-style ml-2 pr-2"} title={"Καταχώρηση επιλεγμένων"}><FaRobot size={22} /> Καταχώρηση επιλεγμένων</div>
                        </Popconfirm>
                        <Popconfirm
                            title={"Επαναεπεξεργασία επιλεγμένων"}
                            description={"Είσαστε σίγουροι ότι θέλετε να επαναεπεξεργαστούν οι επιλογές σας;"}
                            onConfirm={() => onMassReprocess()}
                            okText={"Ναι"}
                            cancelText={"Όχι"}
                        >
                            <div className={"ai-module-button ai-module-reprocess-style ml-2 pr-2"} title={"Επαναεπεξεργασία επιλεγμένων"}><TbReload size={22} /> Επαναεπεξεργασία επιλεγμένων</div>
                        </Popconfirm>
                        <Popconfirm
                            title={"Απόρριψη επιλεγμένων"}
                            description={"Είσαστε σίγουροι ότι θέλετε να απορρίψετε οι επιλογές σας;"}
                            onConfirm={() => onMassDecline()}
                            okText={"Ναι"}
                            cancelText={"Όχι"}
                        >
                            <div className={"ai-module-button ai-module-decline-style ml-2 pr-2"} title={"Απόρριψη επιλεγμένων"}><MdOutlineCancel size={22} /> Απόρριψη επιλεγμένων</div>
                        </Popconfirm>
                        <div className={"ai-module-button ai-module-reprocess-style ml-2 pr-2"} title={"Αποεπιλογή"} onClick={() => {
                            dispatch(setAIMrModuleSelectedRows([]));
                        }}><MdDeselect size={22} /> Αποεπιλογή όλων</div>
                    </div>
                ) : (
                    <div>
                        {aiModuleData.massRegisterApplicable && (
                            <Popconfirm
                                title={"Καταχώρηση όλων"}
                                description={"Είσαστε σίγουροι ότι θέλετε να καταχωρήσετε όλες τις διαθέσιμες επιλογές;"}
                                onConfirm={() => onMassFastSave()}
                                okText={"Ναι"}
                                cancelText={"Όχι"}
                            >
                                <div className={"ai-module-button ai-module-save-style pr-2"} title={"Γρήγορη Καταχώρηση όλων"}><FaRobot size={22} /> Καταχώρηση όλων</div>
                            </Popconfirm>
                        )}
                        {aiModuleData.massReprocessApplicable && (
                            <Popconfirm
                                title={"Επαναεπεξεργασία όλων"}
                                description={"Είσαστε σίγουροι ότι θέλετε να επαναεπεξεργαστούν όλες οι διαθέσιμες επιλογές;"}
                                onConfirm={() => onMassReprocess()}
                                okText={"Ναι"}
                                cancelText={"Όχι"}
                            >
                                <div className={"ai-module-button ai-module-reprocess-style ml-2 pr-2"} title={"Επαναεπεξεργασία όλων"}><TbReload size={22} /> Επαναεπεξεργασία όλων</div>
                            </Popconfirm>
                        )}
                        {aiModuleData.massDeclineApplicable && (
                            <Popconfirm
                                title={"Απόρριψη όλων"}
                                description={"Είσαστε σίγουροι ότι θέλετε να απορρίψετε όλες οι διαθέσιμες επιλογές;"}
                                onConfirm={() => onMassDecline()}
                                okText={"Ναι"}
                                cancelText={"Όχι"}
                            >
                                <div className={"ai-module-button ai-module-decline-style ml-2 pr-2"} title={"Απόρριψη όλων"}><MdOutlineCancel size={22} /> Απόρριψη όλων</div>
                            </Popconfirm>
                        )}
                    </div>
                )}
            </div>
        )
    }

    return (
        <React.Fragment>
            <ReportsTemplate templateType={"ai-mr-module"}
                             requestData={requestData}
                             fetchReport={() => fetchData(false)}
                             setRequestData={(data) => dispatch(setAIMrModuleRequestData(data))}
                             header={"Ανάλυση MyData Παραστατικών - Primer AI"}
            />
            <div onKeyDown={(e) => {
                if (e?.key === "Enter") fetchData(false);
            }}>
                <Row className={"mb-2"}>
                    <Col md={3}>
                        <Dropdown
                            name={"aiModuleType"}
                            label={"Κανάλι AI"}
                            options={aiModuleTemplateTypes}
                            defaultValue={aiModuleTemplateTypes.find((el) => el.value === aiModuleType)}
                            onChange={(e) => dispatch(setAIModuleType(e.value))}
                        />
                    </Col>
                    <Col md={2}>
                        <DateHelper dateFromAndToFunction={(from, to) => dispatch(setAIMrModuleRequestData({...requestData, date_from: from, date_to: to}))} />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            label={"Ημ/νία από"}
                            allowOtherYears={false}
                            selected={moment(requestData.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : null}
                            onChange={(e) => handleFilterChange(e, "datebox", "date_from")}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            label={"Ημ/νία έως"}
                            allowOtherYears={false}
                            selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : null}
                            onChange={(e) => handleFilterChange(e, "datebox", "date_to")}
                        />
                    </Col>
                    <Col md={3}>
                        <Dropdown
                            name={"type"}
                            label={"Κατηγορία Παραστατικού"}
                            options={typeOptions}
                            defaultValue={typeOptions.find((el) => el.value === requestData?.type)}
                            onChange={(e) => handleFilterChange(e, "dd", "type")}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <Dropdown
                            label={"Τύπος Παραστατικού"}
                            name="myDataType"
                            defaultValue={invoiceTypes.filter((el) => requestData.myDataType.includes(el.value))}
                            key={Math.random()}
                            multiSelect={true}
                            options={invoiceTypes}
                            onChange={(e) => handleFilterChange(e, "msdd", "myDataType")}
                        />
                    </Col>
                    <Col md={2}>
                        <Dropdown
                            name={"status"}
                            label={"Κατάσταση Επεξεργασίας AΙ"}
                            multiSelect={true}
                            options={statusOptions}
                            defaultValue={statusOptions.filter((el) => requestData.status.includes(el.value))}
                            onChange={(e) => handleFilterChange(e, "msdd", "status")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            name={"scoreFrom"}
                            type={"number"}
                            label={"Βαθμολογία από"}
                            value={requestData.scoreFrom}
                            onChange={(e) => handleFilterChange(e, "input", "scoreFrom")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            name={"scoreTo"}
                            type={"number"}
                            label={"Βαθμολογία έως"}
                            value={requestData.scoreTo}
                            onChange={(e) => handleFilterChange(e, "input", "scoreTo")}
                        />
                    </Col>
                    <Col md={3}>
                        <Input
                            name={"general"}
                            label={"Γενικό Φίλτρο (Αντισυμβαλλόμενος, MARK, Αρίθμηση)"}
                            value={requestData.general}
                            onChange={(e) => handleFilterChange(e, "input", "general")}
                        />
                    </Col>
                </Row>
                <Row className={"d-flex justify-content-end mb-2"}>
                    <Col md={12} className={"d-flex justify-content-end"}>
                        <Button onClick={() => fetchData()} disabled={loadingData}>
                            Εφαρμογή Φίλτρων & Αναζήτηση {loadingData && <Spinner className={"ml-1"} animation="border" variant="dark" />}
                        </Button>
                    </Col>
                </Row>
                {aiModuleData.totalPages > 0 && (
                    <React.Fragment>
                        <Row>
                            <Col md={8} className={"mb-2"}>
                                {renderMassActions()}
                            </Col>
                            <Col md={4} className={"d-flex justify-content-end"}>
                                <div className="mr-md-3 mt-2 mb-2 mb-md-0 text-center text-md-right">
                                    <i style={{ whiteSpace: 'nowrap' }}>
                                        Σύνολο Αποτελεσμάτων: {aiModuleData.totalRows}
                                    </i>
                                </div>
                                <div className="d-flex justify-content-center justify-content-md-end">
                                    <Pagination
                                        currentPage={requestData.page}
                                        totalPages={aiModuleData.totalPages}
                                        handlePageChange={(page) => onPageChange(page)}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row className={"mb-3"}>
                            <Col md={12}>
                                <table className={"ai-module-table"} style={{tableLayout: "auto"}}>
                                    <colgroup>
                                        <col span={1} style={{width: "3%"}}></col>
                                        <col span={1} style={{width: "5%"}}></col>
                                        <col span={1} style={{width: "5%"}}></col>
                                        <col span={1} style={{width: "15%"}}></col>
                                        <col span={1} style={{width: "5%"}}></col>
                                        <col span={1} style={{width: "25%"}}></col>
                                        <col span={1} style={{width: "6%"}}></col>
                                        <col span={1} style={{width: "20%"}}></col>
                                        <col span={1} style={{width: "3%"}}></col>
                                        {isAdmin && (
                                            <col span={1} style={{width: "3%"}}></col>
                                        )}
                                        <col span={1} style={{width: "15%"}}></col>
                                    </colgroup>
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th>Κατηγορία</th>
                                        <th style={{cursor: "pointer"}} onClick={() => handleSort("date")}>Ημ/νια {renderSortArrow("date")}</th>
                                        <th style={{cursor: "pointer"}} onClick={() => handleSort("myDataType")}>Τύπος Παραστατικού {renderSortArrow("myDataType")}</th>
                                        <th style={{cursor: "pointer"}} onClick={() => handleSort("numbering")}>Αρίθμηση {renderSortArrow("numbering")}</th>
                                        <th style={{cursor: "pointer"}} onClick={() => handleSort("counterpart")}>Πελάτης/Προμηθευτής {renderSortArrow("counterpart")}</th>
                                        <th style={{cursor: "pointer"}} onClick={() => handleSort("totalValue")}>Συν. Αξία {renderSortArrow("totalValue")}</th>
                                        <th style={{cursor: "pointer"}} onClick={() => handleSort("status")}>Κατάσταση Επεξεργασίας AΙ {renderSortArrow("status")}</th>
                                        <th style={{cursor: "pointer"}} onClick={() => handleSort("score")}>Βαθμολογία {renderSortArrow("score")}</th>
                                        {isAdmin && (
                                            <th style={{cursor: "pointer"}} onClick={() => handleSort("credits")}>Credits {renderSortArrow("credits")}</th>
                                        )}
                                        <th>Ενέργειες</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {tableData.length === 0 ? (
                                        <tr>
                                            <td colSpan={9}>Δεν βρέθηκαν δεδομένα.</td>
                                        </tr>
                                    ) : tableData.length > 0 ? tableData.map((o, idx) => {
                                            return (
                                                <tr className={"hover-status"} key={`aiMr-${idx}`}
                                                    style={{cursor: statusesForClickableRows.includes(o.erp_status) ? "pointer" : ""}}
                                                    onClick={() => {
                                                        const selection = window.getSelection();
                                                        if (selection && selection.toString().length > 0) return;
                                                        if (statusesForClickableRows.includes(o.erp_status)) onSave(o);
                                                    }}
                                                    onDoubleClick={() => {
                                                        if ([1000, 10001].includes(o["erp_status"])) {
                                                            if(o["type"] === "Πωλήσεις") {
                                                                handleShowExistingSale(o);
                                                            } else if (o["type"] === "Αγορές & Δαπάνες") {
                                                                handleShowExistingBuy(o);
                                                            }
                                                        }
                                                    }}>
                                                    <td>
                                                        {statusesForCheckboxes.includes(o.erp_status) && (
                                                            <input
                                                                type={"checkbox"}
                                                                checked={aiModuleSelectedRows.some((el) => el._id === o._id)}
                                                                style={{zoom: "1.5"}}
                                                                onClick={(e) => e.stopPropagation()}
                                                                onChange={(e) => handleSelectionChange(e, o)}
                                                            />
                                                        )}
                                                    </td>
                                                    <td>{o["type"]}</td>
                                                    <td>{moment(o["date"]).format("DD/MM/YYYY")}</td>
                                                    <td>{getInvoiceTypeDescription(o["myDataType"])}<br />{`(MARK: ${o["mark"]})`}</td>
                                                    <td>{o["numbering"]}</td>
                                                    <td>{o["counterpart"]}</td>
                                                    <td>{getGreekCurrencyFormat(o["totalValue"])}</td>
                                                    <td className={`status-td ${formatAIDocumentColor(o["erp_status"])}`} style={{fontWeight: "600", letterSpacing: "0.3px", borderRadius: "6px"}}>
                                                        {formatAIDocumentStatus(o["erp_status"], true)}
                                                        {([-121, -123].includes(o?.erp_status) && o?.erp_nonReadableReason) && (
                                                            <span><br/>{o.erp_nonReadableReason}</span>
                                                        )}
                                                    </td>
                                                    <td>{o["erp_score"] || "-"} {o["erp_score"] ? "%" : ""}</td>
                                                    {isAdmin && (
                                                        <td>{o["credits"]}</td>
                                                    )}
                                                    <td>{renderActionButtons(o)}</td>
                                                </tr>
                                            )
                                    }) : (
                                        <React.Fragment></React.Fragment>
                                    )}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </React.Fragment>
                )}
            </div>
            {showSaleModal && (
                <AISaveSaleModal
                    show={showSaleModal}
                    setShow={setShowSaleModal}
                    aiDoc={aiDoc}
                    onSave={handleSaleSave}
                    onReprocess={onReprocess}
                    onDecline={onDecline}
                />
            )}
            {showBuyModal && (
                <AISaveBuyModal
                    show={showBuyModal}
                    setShow={setShowBuyModal}
                    aiDoc={aiDoc}
                    onSave={handleSaveBuy}
                    onReprocess={onReprocess}
                    onDecline={onDecline}
                />
            )}
            {showReprocessModal && (
                <Modal show={showReprocessModal} onHide={() => setShowReprocessModal(false)} backdrop={"static"} dialogClassName={"modal42PercentWidth"}>
                    <Modal.Header closeButton>
                        <Modal.Title>Επαναεπεξεργασία εγγράφου</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Είσαστε σίγουροι ότι θέλετε να αποστείλετε αίτημα επανεπεξεργασίας; Η επαναεπεξεργασία θα εκτελεστεί το συντομότερο δυνατό.
                        {aiDoc.type === "Αγορές & Δαπάνες" && (
                            <div>
                                <div style={{textAlign: "center"}} className={"border-top mt-2"}>
                                    <h6 className={"mt-2"}>Επίπεδο αυστηρότητας εκπιπτόμενου Φ.Π.Α.</h6>
                                </div>
                                <StatusSlider
                                    min={1}
                                    max={5}
                                    labels={vatDeductibleToleranceLabels}
                                    value={vatDeductibleSlider}
                                    onChange={(e) => setVatDeductibleSlider(e)}
                                />
                                <div className={"mt-2"}>
                                    Με την παραπάνω επιλογή, μπορείτε να μεταβάλλετε προσωρινά το επίπεδο αυστηρότητας εκπιπτόμενου Φ.Π.Α. .
                                    Η επιλογή ΔΕΝ θα αποθηκευτεί, και θα έχει ισχύ μόνο γι΄ αυτή την επανεπεξεργασία.<br/>
                                    <u>Η επιλογή λειτουργεί μόνο σε περίπτωση επανεπεξεργασίας χαρακτηρισμών.</u>
                                </div>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-primary" onClick={() => setShowReprocessModal(false)} disabled={loadingReprocess}>
                            Όχι, κλείσιμο
                        </Button>
                        <Button variant="primary" onClick={() => onReprocessDocument(aiDoc)} disabled={loadingReprocess}>
                            Ναι, επαναεπεξεργασία {loadingReprocess && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
            {showDeclineModal && (
                <Modal show={showDeclineModal} onHide={() => setShowDeclineModal(false)} backdrop={"static"}>
                    <Modal.Header closeButton>
                        <Modal.Title>Απόρριψη εγγράφου</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Είσαστε σίγουροι ότι θέλετε να απορρίψετε το έγγραφο που έχει δημιουργήσει το Primer AI; Υπάρχει δυνατότητα επαναδημιουργίας.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-primary" onClick={() => setShowDeclineModal(false)} disabled={loadingDecline}>
                            Όχι, κλείσιμο
                        </Button>
                        <Button variant="outline-danger" onClick={() => onDeclineDocument(aiDoc)} disabled={loadingDecline}>
                            Ναι, απόρριψη {loadingDecline && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
            <Modal show={savingSomething && !showBuyModal && !showSaleModal && !massLoading} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Γρήγορη καταχώρηση</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Γίνεται καταχώρηση, παρακαλώ περιμένετε... <Spinner size={"sm"} className={"ml-2"} animation={"border"} variant={"dark"} />
                </Modal.Body>
            </Modal>
            <Modal show={massLoading} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Μαζική ενέργεια</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Παρακαλώ περιμένετε... <Spinner size={"sm"} className={"ml-2"} animation={"border"} variant={"dark"} />
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default AIModuleMyDataClearance;
